import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledIconWrapper = styled.span`
  display: inline-flex;
  margin-bottom: ${rem('16px')};

  svg {
    width: ${rem('28px')};

    path {
      fill: ${({ theme }) => theme.colors.landlord.main};
    }
  }
`;

export const StyledList = styled.ul`
  margin: 0;
  padding: 0;
`;

export const StyledListItem = styled.li`
  margin-top: ${rem('32px')};
  list-style: none;
`;

export const StyledWrapper = styled.section`
  margin: ${rem('60px')} 0;
`;
